import { render, staticRenderFns } from "./consultDetail.vue?vue&type=template&id=63b12cae&scoped=true&"
import script from "./consultDetail.vue?vue&type=script&lang=js&"
export * from "./consultDetail.vue?vue&type=script&lang=js&"
import style0 from "./consultDetail.vue?vue&type=style&index=0&id=63b12cae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b12cae",
  null
  
)

export default component.exports